import { useTranslation } from 'react-i18next';
import Icons from '../../../../common/widgets/Icons';
import MarketingInfoImg from '../../../../common/assets/images/merchants/marketing-info.png';
import { resources } from '../../resources/resources';

export const MarketingPage = () => {
  const { t: translate } = useTranslation();
  return (
    <>
      <h1>{translate(resources.marketingPage.title)}</h1>
      <div className="notification n-info mkt-notification">
        <div className="notification-icon">
          <Icons.NotificationsInfo />
        </div>
        <ul className="notification-details list-reset">
          <li>
            <span>
              <div
                className="mkt-notification-content"
                dangerouslySetInnerHTML={{
                  __html: translate(resources.marketingPage.infoBox),
                }}
              ></div>
              <img src={MarketingInfoImg} alt="Marketing info image" />
            </span>
          </li>
        </ul>
      </div>
      <div className="m-panel m-mkt-panel">
        <div className="m-mkt-section">
          <h2>{translate(resources.marketingPage.marketingPlan.title)}</h2>
          <p>{translate(resources.marketingPage.marketingPlan.text)}</p>
          <ul
            className="m-mkt-list"
            dangerouslySetInnerHTML={{
              __html: translate(resources.marketingPage.marketingPlan.list),
            }}
          ></ul>
        </div>
        <div className="m-mkt-section">
          <h2>{translate(resources.marketingPage.promo.title)}</h2>
          <p>{translate(resources.marketingPage.promo.text)}</p>
          <ul
            className="m-mkt-list"
            dangerouslySetInnerHTML={{
              __html: translate(resources.marketingPage.promo.list),
            }}
          ></ul>
        </div>
        <div className="m-mkt-section">
          <h2>{translate(resources.marketingPage.banner.title)}</h2>
          <p>{translate(resources.marketingPage.banner.text)}</p>
        </div>
      </div>
    </>
  );
};
